module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/move-vertical-e1b419eeaddd176337eb3d0fd09675c6.svg";